
const initailState = {
    arr:[],
    nextKey:''
}
const AccountsRevenueVehicle=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_REVENUE_VEHICLE_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.nextKey
            }
        default:
            return state;
    }
}

export default AccountsRevenueVehicle